import { useState, useEffect } from 'react';
import { 
  Button, TextField, Grid, Typography, IconButton
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

import { changePassForgot } from '../../actions/users';
import { isEmpty } from '../common/helpers';
import { errorDeContrasena, REGLA_CONTRASENA } from '../../utils/contrasena';

const CrearPass = ({
  user, navigate, setPasos, setExito, userId, token
}) => {
  const [data, setData] = useState({
    password: '',
    password2: ''
  });
  const [error, setError] = useState({
    password: '',
    password2: ''
  });
  const [id, setId] = useState('');

  useEffect(() => {
    if(userId){
      setId(userId);
    } else if(user.user !== null && !isEmpty(user.user._id)){
      setId(user.user._id);
    }
  }, [user.user, userId]);

  const changePass = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  }

  const guardar = async e => {
    e.preventDefault();
    if(isEmpty(data.password)){
      return setError({
        password: 'Un campo esta vacio',
        password2: 'Un campo esta vacio'
      })
    }
    if(data.password !== data.password2){
      return setError({
        password: 'No coinciden',
        password2: 'No coinciden'
      });
    }
    // Lo mismo que pide el servidor: si no, el cambio fallaba al guardar y había que volver a pedir el código
    const errorPass = errorDeContrasena(data.password);
    if(errorPass){
      return setError({
        password: errorPass,
        password2: errorPass
      });
    }
    // `token`: el permiso de un solo uso que dio el servidor al verificar el código
    const info = {
      password: data.password,
      token
    }
    const resChange = await changePassForgot(info, id);
    if(resChange){
      setExito(true);
    }
    setPasos(5);
  }

  return (
    <form noValidate onSubmit={guardar}>
      <Grid container sx={{my:2}} spacing={{ sx: 1}}>
        <Grid size={12}>
          <IconButton
            className="btn-icon"
            aria-label="back"
            onClick={() => navigate(-1)}
          >
            <ChevronLeftIcon />
          </IconButton>
        </Grid>
        <Grid className="step-pass" size={12} container direction="column">
          <Typography variant="h3" component="h3">Crear nueva contraseña</Typography>
        </Grid>
        <Grid size={{xs: 12, md: 8}}>
          <TextField
            error={isEmpty(error.password) ? false : true}
            type="password"
            variant="outlined"
            fullWidth
            id="password"
            label="Contraseña"
            name="password"
            value={data.password}
            onChange={changePass}
            helperText={!isEmpty(error.password) && error.password}
          />
        </Grid>
        <Grid className="content-description" size={{xs: 12, md: 8}} sx={{ mb: 2 }}>
          <h5>{REGLA_CONTRASENA}</h5>
        </Grid>
        <Grid size={{xs: 12, md: 8}}>
          <TextField
            error={isEmpty(error.password2) ? false : true}
            type="password"
            variant="outlined"
            fullWidth
            id="password2"
            label="Confirmar password"
            name="password2"
            value={data.password2}
            onChange={changePass}
            helperText={!isEmpty(error.password2) && error.password2}
          />
        </Grid>
      </Grid>
      <Grid size={12} sx={{mt: 3}}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
        >
          Guardar
        </Button>
      </Grid>
    </form>
  );
}

CrearPass.propTypes = {
  user: PropTypes.object.isRequired,
}

export default CrearPass;